var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-big-logo"},[_c('div',{staticClass:"container-fluid"},[_c('router-link',{staticClass:"d-flex align-items-center",attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.setting.logo.logo}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }